var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "43litpgmxa",
    d: "M0.861 0.789L3.475 0.789 3.475 7.289 0.861 7.289z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xgpr252qnc",
    d: "M0.822 0.789L3.436 0.789 3.436 7.289 0.822 7.289z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kj0cjyribe",
    d: "M0.783 0.789L3.397 0.789 3.397 7.289 0.783 7.289z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bfm0hh8weg",
    d: "M0 0.789L2.614 0.789 2.614 7.289 0 7.289z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 .11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ivcsh3443b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#43litpgmxa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M1.656 7.289S.136 4.886 1.3 3.224C2.465 1.563 2.27.79 2.27.79s2.443 2.42.372 6.484c-.016-2.339-.582-2.226-.582-2.226s-.566-.21-.404 2.242",
    mask: "url(#ivcsh3443b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M6.672 8.1V6.165h-.147v1.931c-.43-.003-.592-.04-1.1-.154-.008-.191 0 17.368 0 17.368h2.343V7.943s-.26.146-1.096.156M6.25 9.6c.232 0 .419.187.419.418 0 .23-.187.418-.419.418-.231 0-.42-.187-.42-.418 0-.231.189-.417.42-.417m0 4.474c.232 0 .419.187.419.418 0 .23-.187.418-.419.418-.231 0-.42-.188-.42-.418 0-.231.189-.418.42-.418m.628 2.996c0 .115-.093.208-.21.208-.114 0-.208-.093-.208-.208 0-.116.094-.21.209-.21.116 0 .21.094.21.21M5.83 19.192c0-.23.188-.418.42-.418.23 0 .418.187.418.418 0 .231-.187.418-.419.418-.231 0-.42-.187-.42-.418m.839 4.682c-.174 0-.314-.14-.314-.314 0-.172.14-.313.314-.313.173 0 .314.14.314.313 0 .174-.14.314-.314.314m.42-3.436c-.078 0-.141-.063-.141-.14 0-.077.063-.14.14-.14.078 0 .14.063.14.14 0 .077-.062.14-.14.14m-.21-7.37c-.347 0-.628-.282-.628-.628 0-.346.281-.626.628-.626.348 0 .629.28.629.626s-.281.627-.629.627"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.9 .11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vqf10fs3kd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xgpr252qnc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M1.616 7.289s-1.52-2.403-.355-4.065c1.165-1.661.97-2.435.97-2.435s2.443 2.42.372 6.484c-.016-2.339-.582-2.226-.582-2.226s-.567-.21-.405 2.242",
    mask: "url(#vqf10fs3kd)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M13.202 22.26v-1.905l-2.344 1.944.001 1.903 2.343-1.943zM10.857 17.035v1.904l2.345-1.944V15.09l-2.345 1.945zM13.202 9.097V7.943s-.26.146-1.095.156V6.165h-.148v1.933c-.43-.004-.591-.04-1.099-.155-.003-.052-.004 1.224-.004 3.1l2.346-1.946zM10.858 19.667v1.903l2.344-1.944v-1.904l-2.344 1.945zM10.86 24.93v.38H13.2v-2.323L10.86 24.93zM10.856 11.772v1.904l2.346-1.946V9.826l-2.346 1.946zM10.856 14.403v1.905l2.346-1.946v-1.904l-2.346 1.945z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.3 .11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uxnel68pof",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kj0cjyribe"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M1.577 7.289s-1.52-2.403-.355-4.065c1.165-1.661.97-2.435.97-2.435s2.443 2.42.372 6.484c-.016-2.339-.582-2.226-.582-2.226s-.567-.21-.405 2.242",
    mask: "url(#uxnel68pof)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M18.02 16.45c-.028 0-.054-.01-.074-.029l-.552-.552-.56.558c-.02.02-.046.031-.072.031-.026 0-.052-.01-.073-.03l-.474-.472.001 1.733.546.544.559-.557c.02-.02.046-.03.073-.03.027 0 .054.01.072.03l.553.55.542-.54v-1.733l-.469.468c-.02.019-.046.03-.073.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M18.02 18.474c-.028 0-.054-.01-.074-.03l-.552-.551-.56.558c-.02.02-.046.03-.072.03-.026 0-.052-.01-.073-.03l-.473-.472v1.734l.546.543.559-.557c.02-.02.046-.03.073-.03.027 0 .054.01.072.03l.553.55.542-.54v-1.733l-.469.468c-.02.02-.046.03-.073.03M18.02 14.428c-.028 0-.054-.011-.074-.03l-.552-.552-.56.558c-.02.02-.046.03-.072.03-.026 0-.052-.01-.073-.03l-.474-.472v1.733l.547.545.559-.557c.02-.02.046-.031.073-.031.027 0 .054.01.072.03l.553.551.542-.54V13.93l-.469.468c-.02.019-.046.03-.073.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M18.02 20.497c-.028 0-.054-.01-.074-.03l-.552-.551-.56.558c-.02.02-.046.03-.072.03-.026 0-.052-.01-.073-.03l-.472-.47v1.734l.545.542.559-.558c.02-.02.046-.03.073-.03.027 0 .054.01.072.03l.553.551.542-.54V20l-.469.468c-.02.019-.046.03-.073.03M18.092 24.514c-.02.019-.045.03-.073.03-.027 0-.053-.011-.073-.03l-.552-.55-.56.557c-.02.02-.045.03-.072.03-.027 0-.053-.01-.072-.03l-.471-.47v1.26h2.342v-1.265l-.47.468zM16.762 10.14l.559-.558c.02-.019.046-.03.073-.03.028 0 .054.011.073.03l.552.55.542-.54v-1.65s-.258.147-1.095.157V6.166h-.148v1.931c-.43-.003-.591-.04-1.099-.155-.002-.037-.003.605-.003 1.654l.546.544zM18.02 12.404c-.028 0-.054-.01-.074-.03l-.552-.551-.56.558c-.02.02-.046.03-.072.03-.026 0-.052-.01-.073-.03l-.474-.473v1.734l.547.545.559-.558c.02-.02.046-.03.073-.03.027 0 .054.01.072.03l.553.55.542-.54v-1.733l-.469.468c-.02.02-.046.03-.073.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M17.321 23.745c.019-.019.046-.03.073-.03.027 0 .053.011.073.03l.553.551.541-.54v-1.733l-.47.468c-.018.019-.044.03-.071.03-.028 0-.054-.011-.073-.03l-.553-.551-.56.558c-.02.02-.046.03-.072.03-.027 0-.053-.01-.073-.03l-.471-.47v1.734l.544.541.56-.558zM18.02 10.38c-.028 0-.054-.01-.074-.029l-.552-.552-.56.558c-.02.021-.046.031-.072.031-.026 0-.052-.01-.073-.03l-.474-.472v1.732l.547.546.559-.558c.02-.02.046-.03.073-.03.027 0 .054.01.072.03l.553.55.542-.54V9.883l-.469.468c-.02.02-.046.03-.073.03"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6my9t8p41h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bfm0hh8weg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M.795 7.289S-.725 4.886.439 3.224C1.604 1.563 1.41.79 1.41.79s2.443 2.42.372 6.484C1.765 4.934 1.2 5.047 1.2 5.047s-.566-.21-.404 2.242",
    mask: "url(#6my9t8p41h)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M1.384 8.1V6.165h-.147v1.931c-.43-.003-.591-.04-1.099-.154-.009-.191 0 17.368 0 17.368H2.48V7.943s-.259.146-1.096.156"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForty);
export default __webpack_public_path__ + "static/media/forty.e7d63087b89efaa0aef456417052aa7c.svg";
export { ForwardRef as ReactComponent };